import React, {useContext} from 'react';
import InstallerContext from "@/context/InstallerContext";

const GameCard = ({id, name, image, selected}) => {
  const {setGame} = useContext(InstallerContext)
  
  return (
      <div
          onClick={() => setGame(id)}
          className={`game-card ${selected && 'active' }`}
      >
        <img src={image} alt={name} className="w-full" />
        <div className="game-name">
          {name}
        </div>
      </div>
  );
};

export default GameCard;